<div style="display: flex; justify-content: center; padding-top: 20px;" *ngIf="viewMode">
  <mat-button-toggle-group [formControl]="viewMode">
    <mat-button-toggle [value]="ViewMode.Desktop">Desktop</mat-button-toggle>
    <mat-button-toggle [value]="ViewMode.Mobile">Mobiel</mat-button-toggle>
  </mat-button-toggle-group>
</div>
